import moment from 'moment';

export class Helper {
  public formatMoney(num: string): string {
    return Number(num).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  public formatDateTimeThai(date: Date | undefined): string {
    let strMonthCut = ['', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
    if (date) {
      let newDate = new Date(date).getTime();
      let years = Number(moment(newDate).format('YYYY'));
      let month = strMonthCut[Number(moment(newDate).format('MM'))];
      let day = moment(newDate).format('DD');
      let time = moment(newDate).format('HH:mm');
      return `${day} ${month} ${years} ${time} น.`;
    } else {
      return ''
    }
  }

  public formatDateThai(date: Date): string {
    let strMonthCut = ['', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
    if (date) {
      let newDate = new Date(date).getTime();
      let years = Number(moment(newDate).format('YYYY')) + 543;
      let month = strMonthCut[Number(moment(newDate).format('MM'))];
      let day = moment(newDate).format('DD');
      return `${day} ${month} ${years}`;
    } else {
      return ''
    }
  }

  public formatTime(date: Date): string {
    if (date) {
      let newDate = new Date(date).getTime();
      return moment(newDate).format('HH:mm');
    } else {
      return ''
    }
  }
}
